const NaStringRenderer = (props) => {
  return props.value == null ? 'N/A' : props.value;
};

export default NaStringRenderer;
